module.exports = __webpack_public_path__ + "static/media/black_paper.79f94807.png";